import React from "react";
import { map, size } from "lodash";
import {TouchCheckbox, TouchNumber} from "../../AtollonTheme/ReactElements";

const ContactsHeader = ({ history, buttons, location }) => {
  return (
    <div className="flex-row flex-centered ">
      {map(buttons, (item, i) => {

        const uniqueReactKey = i;
        const name = item.label;
        const currentPageLink = window.location.pathname;
        const isChecked = item.link === currentPageLink;
        const count = size( item.array );

        return (
              <span
                  key={uniqueReactKey}
                  className={`touchCheckboxWithLabel-spaceBetween ContactsHeader-NavLink ${isChecked? 'ContactsHeader-NavLink--active' : ''}`}
                  onClick={()=>
                  {
                        history.push( item.link );
                  }}
              >
                  <TouchCheckbox
                      id={i}
                      label={
                          <div className="touchCheckboxWithLabel-labelPadding">
                              <div className="touchCheckboxWithLabel-label">{name}</div>
                              <TouchNumber text={count} className="touchCheckboxWithLabel-TouchNumber"/>
                          </div>
                      }
                      name="requestTypes"
                      checked={isChecked}
                      onChange={boolean => {

                      }}
                  />
              </span>
        );
      })}
    </div>
  );
};

export default ContactsHeader;



// WEBPACK FOOTER //
// ./src/components/contacts/ContactsHeader.js